module.exports = __webpack_public_path__ + "img/26.e8f3a7c0.jpg";